import axios from '../../plugins/axios';
import { Message } from 'element-ui';

export const shipping_module = {
    state: ()=>({
        pending: false,
        loadingMore: false,
        data: {
            current_page: 1,
            data: [],
            last_page: null,
            searchedKeyword:'',
            filter:{
                status:[],
            },
            allFilters:[],
        },
        message: null,
        success: null,
        error: null
    }),
    mutations: {
        fetch_regions_request(state,loadingType){

            if(loadingType == 'new'){

                state.pending = true;

            }else if(loadingType == 'more'){

                state.loadingMore = true;

            }

        },
        fetch_regions_success(state, payload){

            if(payload.loadData == 'new'){

                state.data.data = payload.regions.data;

            }else if(payload.loadData == 'more'){

                state.data.data.push(...payload.regions.data);

            }

            state.data.current_page = payload.regions.current_page;
            state.data.last_page = payload.regions.last_page;
            state.pending = false;
            state.loadingMore = false;
            state.success = true;
            state.error = null;
            state.message = payload.message;

        },
        fetch_regions_failure(state, payload){

            state.data.data = [];
            state.pending = false;
            state.loadingMore = false;
            state.success = false;
            state.error = payload.error;
            state.message = payload.message;

        },
        add_regions_list(state,payload){

            state.data.data.unshift(payload);

        },
        update_regions_list(state,payload){

            const index = state.data.data.findIndex(x=>x.id === payload.id);
  
            if(index !== -1){

                state.data.data[index] = payload;

            }

        },
        update_regions_status(state,payload){

            state.data.data[payload.index].isActive = payload.updatedRegion.isActive;

        },
        selective_region_update(state,payload){

            let regionIndex = state.data.data.findIndex((listedRegion) => listedRegion.id == payload.region.id);

            if(regionIndex != -1){

                state.data.data[regionIndex].name = payload.region.name;
    
            }

        },
        delete_regions_list(state,payload){
            
            state.data.data.splice(payload,1);

        },
        regions_bulk_action(state,payload){

            if(payload.action == 'delete'){

                state.data.data = state.data.data.filter((region)=>{

                    if(!payload.listIds.includes(region.id)){
                        
                        return region;

                    }

                });

            }else if(payload.action == 'statusChange'){
                
                state.data.data.forEach((region) =>{

                    if(payload.listIds.includes(region.id)){

                        region.isActive = payload.status;

                    }

                });

            }

        },
        update_searched_keyword(state,payload){ 

            state.data.searchedKeyword = payload.keyword;

        },
        remove_searched_keyword(state){

            state.data.allFilters = []

            state.data.searchedKeyword = '';

        },
        update_shipping_filters(state,payload){

            state.data.filter.status = payload.status

        },
        update_shipping_all_filters(state,payload){

            state.data.allFilters = payload

        },
        remove_shipping_filters(state){

            state.data.filter.status = []

        },
        CLEAR_MODULE(state){

            state.pending = false;
            state.loadingMore = false;
            state.message = null;
            state.success = null;
            state.error = null;

            state.data.current_page = 1;
            state.data.data = [];
            state.data.last_page = null;
            state.data.filter = {
                status:[],
            }
            state.data.allFilters = []

        }
    },
    actions:{

        async fetchStoreRegionsRequest({commit},{size, page, loadData}){

            commit('fetch_regions_request',loadData);

            const searchedKeyword = this.state.shipping_module.data.searchedKeyword;
            let status = this.state.shipping_module.data.filter.status[0];

            try{
                let res = await axios.get('/shipping/region/all',{
                    params:{
                        search: searchedKeyword.length > 0 ? searchedKeyword : null,
                        offset: size,
                        page: page,
                        active: status ? status == 'active' ? 1 : 0 : null,
                    }
                });
                if(res.data.status_code == '1011'){

                    res.data.loadData = loadData;

                    commit('fetch_regions_success', res.data);

                }
            }catch(ex){

                Message({
                    type: 'error',
                    showClose: true,
                    message: ex.response ? ex.response.data.message : ex.message,
                });

                commit('fetch_regions_failure', {error: ex, message: ex});

            }
            
        }
    },
    getters: {
        regions(state){

            return state.data.data;

        },
        keyword(state){

            return state.data.searchedKeyword;

        },
        currentPage(state){

            return state.data.current_page;

        },
        lastPage(state){

            return state.data.last_page;

        },
        isPending(state){

            return state.pending;

        },
        isLoadingMore(state){

            return state.loadingMore;

        },
        filters(state){

            return state.data.filter;

        },
        allFilters(state){

            return state.data.allFilters;

        },
        message(state){

            return state.message;
            
        },
        error:(state)=>state.error
    }
}